<template>
  <el-button type="primary" size="mini" @click="childclick">
    <slot>确定</slot>
  </el-button>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    childclick() {
      this.$emit('click');
    }
  }
};
</script>
<style lang="scss" scoped>
</style>